import { Skeleton } from "antd";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function CVInfo({ data, loading }: Props) {
  if (loading) {
    return (
      <Section title="সিভি" type="cv">
        <Skeleton active paragraph={{ rows: 2 }} />
      </Section>
    );
  }

  const cvUrl = data?.cvFileUrl;

  return (
    <Section title="সিভি" type="cv">
      {cvUrl ? (
        <Info img={cvUrl} />
      ) : (
        <div className="text-sm text-gray-500">কোন তথ্য নেই</div>
      )}
    </Section>
  );
}
